export default "__VITE_ASSET__COknrcpD__"